import { SET_RESTAURANT_SEARCH_FILTER } from "../types/restaurant.types";

export const setRestaurantFilter = (value) => {
  return {
    type: SET_RESTAURANT_SEARCH_FILTER,
    value,
  };
};